"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _HBNewTable = require("./HBNewTable.styles");
var NewTableCellList = function NewTableCellList(_ref) {
  var columnDefinitions = _ref.columnDefinitions,
    item = _ref.item,
    isRowHovered = _ref.isRowHovered,
    itemId = _ref.itemId,
    isRowExpanded = _ref.isRowExpanded,
    setIsRowExpanded = _ref.setIsRowExpanded;
  return columnDefinitions.map(function (cell) {
    var key = "".concat(itemId, " ").concat(cell.title || cell.id);
    return /*#__PURE__*/_react["default"].createElement(_HBNewTable.NewTableStyledTd, {
      key: key
    }, cell.renderCell(item, {
      isRowHovered: isRowHovered,
      isRowExpanded: isRowExpanded,
      setIsRowExpanded: setIsRowExpanded
    }));
  });
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(NewTableCellList);
//# sourceMappingURL=HBNewTableCellList.js.map